import { render, staticRenderFns } from "./CommsMessage.vue?vue&type=template&id=40b316e3&scoped=true"
import script from "./CommsMessage.vue?vue&type=script&lang=js"
export * from "./CommsMessage.vue?vue&type=script&lang=js"
import style0 from "./CommsMessage.vue?vue&type=style&index=0&id=40b316e3&prod&lang=scss&scoped=true"
import style1 from "./CommsMessage.vue?vue&type=style&index=1&id=40b316e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b316e3",
  null
  
)

export default component.exports